export declare type CourseItemTab = "theory" | "tests" | "tasks" | "rating";

export type AXLSchoolEventType = "CourseItemChanged";
export type CourseItemChangedPayload = {
  courseId: string;
  courseItemId: string;
  tab: CourseItemTab;
  studentId?: string;
};
export type CourseItemSDK = {
  id: string;
  name: string;
  type: "step" | "section";
  taskTotal: number;
  taskCompleted: number;
  completed: boolean;
  itemsCount: number;
  stepsCount: number;
  items: CourseItemSDK[];
};

export type CourseSDK = {
  id: string;
  license: {
    type: "simple" | "subscription";
    dateStart?: Date;
    dateEnd?: Date;
  };
  name: string;
  progress: number;
  itemsTotal: number;
  itemsCompleted: number;
  items: CourseItemSDK[];
};

export interface ISchoolSDK {
  currentCourse?: CourseSDK;
  addEventListener(
    event: AXLSchoolEventType,
    callback: (data: any) => void,
  ): void;
  removeEventListener(
    event: AXLSchoolEventType,
    callback: (data: any) => void,
  ): void;
  dispatch(event: AXLSchoolEventType, data: any): void;
  dispatchCourseItemChanged(payload: CourseItemChangedPayload): void;
}

export default class SchoolSDK implements ISchoolSDK {
  private listeners: { [key: string]: ((data: any) => void)[] } = {};

  public currentCourse?: CourseSDK;

  addEventListener(event: AXLSchoolEventType, callback: (data: any) => void) {
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(callback);
  }

  removeEventListener(
    event: AXLSchoolEventType,
    callback: (data: any) => void,
  ) {
    if (!this.listeners[event]) return;
    this.listeners[event] = this.listeners[event].filter((x) => x != callback);
  }

  dispatch(event: AXLSchoolEventType, data: any) {
    if (!this.listeners[event]) return;
    this.listeners[event].forEach((x) => x(data));
  }

  dispatchCourseItemChanged(payload: CourseItemChangedPayload) {
    this.dispatch("CourseItemChanged", payload);
  }
}
